import { StoreGiftCardAdapter } from '../infra/adapters/storeGiftCard.adapter';
import { StoreGiftCardService } from '../application/services/StoreGiftCardService';

export const buildStoreGiftCard = () => {
  const repository = new StoreGiftCardAdapter();
  const service = new StoreGiftCardService(repository);

  return { service };
};